import LandingPageWithLinks from 'Components/Generic/LandingPageWithLinks';
import { SITE_PAGES } from 'Config';
import PropTypes from 'prop-types';
import { isUserAuthorized } from 'Util';

const AccountLanding = ({
  title = '',
  titleButton,
  breadcrumbs = [],
  children,
}) => {
  let allBreadcrumbs = [SITE_PAGES.ACCOUNT_LANDING, ...breadcrumbs];

  let navLinks = [
    SITE_PAGES.ABR_CODE,
    SITE_PAGES.EXPENSE_CODE,
    SITE_PAGES.ALL_ACCOUNTS,
    SITE_PAGES.BUDGETS,
  ].filter((page) => isUserAuthorized(page.requiredAuth));

  return (
    <LandingPageWithLinks
      landingTitle='Account Management'
      links={navLinks}
      pageTitle={title}
      titleButton={titleButton}>
      {children}
    </LandingPageWithLinks>
  );
};

AccountLanding.propTypes = {
  title: PropTypes.string,
  titleButton: PropTypes.node,
  breadcrumbs: PropTypes.array,
  children: PropTypes.node,
};

export default AccountLanding;
